import { render, staticRenderFns } from "./OpportunitiesRegistration.vue?vue&type=template&id=76da095b"
import script from "./OpportunitiesRegistration.vue?vue&type=script&lang=js"
export * from "./OpportunitiesRegistration.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesRegistration.vue?vue&type=style&index=0&id=76da095b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports